"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.DynamicHeadingLevelProvider = exports.DynamicHeading = void 0;
var _reactAccessibleHeadings = require("react-accessible-headings");
var _jsxRuntime = require("react/jsx-runtime");
const DynamicHeadingLevelProvider = function (props) {
  const {
    value,
    hClassName,
    children
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAccessibleHeadings.Level, {
    value: value,
    hClassName: hClassName,
    "data-testid": "DynamicHeadingLevelProvider",
    children: children
  });
};
exports.DynamicHeadingLevelProvider = DynamicHeadingLevelProvider;
const DynamicHeading = function (props) {
  const {
    level,
    defaultLevel = 0,
    children
  } = props;
  const currentLevel = (0, _reactAccessibleHeadings.useLevel)();
  let offset = 0;
  if (currentLevel === 0 && defaultLevel > 0) {
    // Clamp default level value to ensure it is between h2 and h6
    const clampedDefaultLevel = Math.max(1, Math.min(defaultLevel, 5));
    offset = clampedDefaultLevel - 1;
  }
  if (level) {
    // Clamp level value to ensure it is between h1 and h6
    const clampedLevel = Math.max(1, Math.min(level, 6));
    offset = clampedLevel - currentLevel;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAccessibleHeadings.H, {
    ...props,
    offset: offset,
    "data-testid": "DynamicHeading",
    children: children
  });
};
exports.DynamicHeading = DynamicHeading;
const H1 = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicHeading, {
    level: 1,
    ...props,
    "data-testid": "H1"
  });
};
exports.H1 = H1;
const H2 = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicHeading, {
    level: 2,
    ...props,
    "data-testid": "H2"
  });
};
exports.H2 = H2;
const H3 = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicHeading, {
    level: 3,
    ...props,
    "data-testid": "H3"
  });
};
exports.H3 = H3;
const H4 = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicHeading, {
    level: 4,
    ...props,
    "data-testid": "H4"
  });
};
exports.H4 = H4;
const H5 = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicHeading, {
    level: 5,
    ...props,
    "data-testid": "H5"
  });
};
exports.H5 = H5;
const H6 = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicHeading, {
    level: 6,
    ...props,
    "data-testid": "H6"
  });
};
exports.H6 = H6;